import { render, staticRenderFns } from "./HowWorksComponent.vue?vue&type=template&id=cf2a7244&scoped=true&"
import script from "./HowWorksComponent.vue?vue&type=script&lang=js&"
export * from "./HowWorksComponent.vue?vue&type=script&lang=js&"
import style0 from "./HowWorksComponent.vue?vue&type=style&index=0&id=cf2a7244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2a7244",
  null
  
)

export default component.exports